// Resolves which employer entity a logged-in employer-side account acts as. Only the
// original employer signup's own auth.uid() equals employers.id directly -- an invited
// employer_staff seat has a different auth.uid() but acts on the owner's employer_id, and
// this is the one place that distinction gets resolved so every employer-side page agrees.
export async function resolveEmployerId(supabase, userId) {
  // is_active is a real access gate, not a display flag: a deactivated seat resolves to no
  // employer at all, so every caller (login routing, the dashboard, PostJob) turns them away
  // rather than rendering employer chrome for someone the owner has switched off.
  const { data: staffRow } = await supabase.from('employer_staff').select('employer_id').eq('user_id', userId).eq('is_active', true).maybeSingle();
  if (staffRow?.employer_id) return staffRow.employer_id;

  // Fallback/self-heal: an owner whose employer_staff row is missing (predates this feature
  // and the backfill missed them, or the signup RPC call failed) is still the owner if
  // `employers.id` matches their own uid -- recognize that and repair the missing row so
  // future loads don't need this fallback.
  const { data: ownerRow } = await supabase.from('employers').select('id').eq('id', userId).single();
  if (ownerRow) {
    await supabase.rpc('bootstrap_employer_owner_staff');
    return ownerRow.id;
  }
  return null;
}
